import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
export function OfferBlock() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-lighter px-4 py-16 md:py-24" data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-center" data-id="element-101">
          <div className="space-y-4" data-id="element-102">
            <p className="font-inter text-lg md:text-xl text-text/80 leading-relaxed max-w-2xl mx-auto" data-id="element-103">
              Tu atención vale miles de euros para las empresas de publicidad.
              Recupérala hoy mismo por una fracción de ese precio.
            </p>

            <div id="offer" className="inline-flex items-center gap-2 bg-amber/20 border border-amber/40 rounded-full px-4 py-2 scroll-mt-8" data-id="element-104">
              <SparklesIcon className="w-4 h-4 text-amber" data-id="element-105" />
              <span className="font-inter text-sm font-semibold text-amber uppercase tracking-wide" data-id="element-106">
                Precio Especial de Lanzamiento
              </span>
            </div>
          </div>

          <div className="py-6" data-id="element-107">
            <div className="inline-block space-y-2" data-id="element-108">
              <p className="font-inter text-2xl md:text-3xl text-text/40 line-through" data-id="element-109">
                $47 USD
              </p>
              <p className="font-bebas text-7xl md:text-8xl text-white" data-id="element-110">
                $17{' '}
                <span className="text-4xl md:text-5xl text-text/60" data-id="element-111">USD</span>
              </p>
              <p className="font-inter text-sm font-semibold text-teal" data-id="element-112">
                Ahorras $30 — Solo por tiempo limitado
              </p>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-113">
            <a href="https://openforgeworks.com/cart/53167402320237:1" target="_blank" rel="noopener noreferrer" className="group bg-teal hover:bg-teal/90 text-dark font-inter font-bold text-xl px-12 py-6 rounded-lg transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-3 shadow-lg shadow-teal/20" data-id="element-114">
              QUIERO MI REINICIO DE 7 DÍAS
              <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-115" />
            </a>
          </motion.div>

          <p className="font-inter text-sm text-text/60 pt-4" data-id="element-116">
            Acceso inmediato tras la compra. Empieza tu reinicio ahora mismo.
          </p>
        </motion.div>
      </div>
    </section>;
}